import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import { l10n } from '@ott/l10n';

class AuthErrorShower extends React.PureComponent {
  static propTypes = {
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.handleErrorModalClose = this.handleErrorModalClose.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  handleErrorModalClose() {}

  parseError(error) {
    switch (error.error || error) {
      case 'EMAIL_NOT_VALID':
        return l10n('auth.emailFormat');
      case 'PWD_NOT_CONFIRMED':
        return l10n('auth.passwordsNotEqual');
      case 'PWD_TOO_SHORT':
        return l10n('auth.passwordShort');
      case 'PWD_EMPTY_OR_TOO_SMALL':
        return l10n('auth.passwordShort');
      case 'INVALID_PASSWORD':
      case 'INVALID_LOGIN':
      case 'WRONG_PWD_OR_EMAIL':
        return l10n('auth.wrongData');
      case 'NOT_REGISTERED':
        return l10n('auth.notRegistered');
      case 'EMAIL_EXISTS':
      case 'USER_ALREADY_EXIST': {
        const email = _get(error, 'customerInfo.params.email', '');
        return l10n('auth.alreadyHas', { email });
      }
      case 'LIMIT_REACHED':
        return l10n('auth.limitReached');
      case 'TOO_MANY_TRIES':
        return l10n('auth.tooManyTries');
      case 'PHONE_NOT_REGED':
        return l10n('auth.phoneNotReged');
      case 'WEAK_PASSWORD':
        return l10n('auth.weakPassword');
      default:
        return l10n('errors.SYSTEM_ERROR.text');
    }
  }

  renderError(error) {
    if (error) {
      return this.parseError(error);
    }
  }

  render() {
    return null;
  }
}

export default AuthErrorShower;
